import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import ConsoleWrapper from '../../../components/endpoints-page/console';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Action Register Endpoint`}</h2>
    <p>{`GIPHY’s Action Register registers each time a user views, clicks, or sends a GIF or Sticker and plays an important role in helping GIPHY improve your user’s search results.`}</p>
    <h3>{`INSTRUCTIONS`}</h3>
    <p>{`On almost all of our endpoints we return an `}<a href="/docs/api/schema#analytics-object">{`Analytics Object`}</a>{` for each of the GIF in the response for most endpoints.`}</p>
    <p>{`To register an action when user views/clicks/sends a GIF, you should make a request by hitting the corresponding URL in the `}<a href="/docs/api/schema#analytics-object">{`Analytics Object`}</a>{` as such, and append the required params in the URL.`}</p>
    <ConsoleWrapper mdxType="ConsoleWrapper">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Impression`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Click`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Send`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`GET analytics->onload->url`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`GET analytics->onclick->url`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`GET analytics->onsent->url`}</td>
          </tr>
        </tbody>
      </table>
    </ConsoleWrapper>
    <h3>{`BEST PRACTICE`}</h3>
    <p>{`We recommend getting a Random ID for each user by using the `}<a href="/docs/api/endpoint#random-id">{`Random ID Endpoint`}</a>{`. This will allow GIPHY’S API to adjust responses to your users without the use of personally identifiable information.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Request Parameters:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description:`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`random_id:`}</strong>{` `}<em parentName="td">{`string(required)`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`e826c9fc5c929e0d6c6d423841a282aa`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An ID/proxy for a specific user.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`ts:`}</strong>{` `}<em parentName="td">{`integer (int)(required)`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`1527703430507`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A UNIX timestamp in milliseconds corresponding to when the action occurred.`}</td>
        </tr>
      </tbody>
    </table>
    <h5>{`Successful Response (200 OK)`}</h5>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      